import { FileSearch, KeyRound, Truck, Sparkles } from "lucide-react";

const STEPS = [
    {
        n: "01",
        icon: FileSearch,
        title: "Demande",
        desc: "Renseignez votre trajet, le type de véhicule et la date souhaitée. Recevez un devis instantané et transparent.",
    },
    {
        n: "02",
        icon: KeyRound,
        title: "Prise en charge",
        desc: "Un convoyeur Carvaelis vérifié récupère le véhicule au point de départ, état des lieux signé en photos.",
    },
    {
        n: "03",
        icon: Truck,
        title: "Convoyage",
        desc: "Suivi GPS en temps réel, communication directe avec le convoyeur, assurance tous risques activée.",
    },
    {
        n: "04",
        icon: Sparkles,
        title: "Livraison",
        desc: "Remise des clés à destination, validation conjointe et notation du convoyeur sur la plateforme.",
    },
];

export default function HowItWorks() {
    return (
        <section
            id="how-it-works"
            data-testid="how-it-works"
            className="section-y bg-[#F8F9FA] relative"
        >
            <div className="container-x">
                <div className="grid lg:grid-cols-12 gap-12 mb-20">
                    <div className="lg:col-span-5">
                        <p className="text-xs uppercase tracking-[0.2em] text-signal font-bold mb-4">
                            — Comment ça marche
                        </p>
                        <h2
                            data-testid="how-it-works-title"
                            className="font-display font-black tracking-tighter text-ink text-4xl sm:text-5xl lg:text-6xl leading-[0.95]"
                        >
                            Quatre étapes.
                            <br />
                            Aucune surprise.
                        </h2>
                    </div>
                    <div className="lg:col-span-6 lg:col-start-7 flex items-end">
                        <p className="text-lg text-slate-600 leading-relaxed">
                            De la demande de devis à la remise des clés,
                            chaque étape est pensée pour la transparence,
                            la sécurité et la simplicité. Aucune zone
                            d'ombre — vous gardez le contrôle.
                        </p>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-slate-200 border border-slate-200">
                    {STEPS.map((s, i) => {
                        const Icon = s.icon;
                        return (
                            <div
                                key={s.n}
                                data-testid={`how-step-${i}`}
                                className="group bg-white p-8 lg:p-10 hover:bg-ink transition-colors duration-500 relative cursor-default"
                            >
                                <div className="flex items-start justify-between mb-12">
                                    <span className="font-display font-black text-5xl text-slate-200 group-hover:text-signal transition-colors tracking-tighter">
                                        {s.n}
                                    </span>
                                    <Icon
                                        className="w-7 h-7 text-ink group-hover:text-white transition-colors"
                                        strokeWidth={1.5}
                                    />
                                </div>
                                <h3 className="font-display font-bold text-2xl text-ink group-hover:text-white transition-colors mb-3">
                                    {s.title}
                                </h3>
                                <p className="text-sm text-slate-600 group-hover:text-white/70 transition-colors leading-relaxed">
                                    {s.desc}
                                </p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
